import {
  GiftItemType,
  GiftItemStatus,
  IGiftItemResponse,
  Switch,
  colors,
} from '@one-tree/library'
import React, { ReactElement } from 'react'
import styled from 'styled-components'
import { useOrganisation } from '../context/OrganisationProvider'
import { ICategoryResponse } from '../types/API'
import { patchGiftItem } from '../helpers/APIItemHelper'
import { getItemStatusText } from '../helpers/GiftItemHelper'
import { isGiftItemValid } from '../helpers/GiftItemValidityHelper'
import { publishFreeTicketWarning } from '../pages/manage/giftItem/designElements/TicketPrices/pricesHelper'

const CompLabel = styled.div<{ small?: boolean }>`
  color: ${colors.darkerGray};
  ${({ small }): string => (small ? 'font-size: 0.9rem' : '')};
`
type Props = {
  item: IGiftItemResponse
  onSwitch: (item: IGiftItemResponse) => void
  flipLabel?: boolean
  small?: boolean
  categories?: ICategoryResponse[]
}
export default function PublishSwitch(props: Props): ReactElement {
  const {
    item, onSwitch, flipLabel, small, categories,
  } = props
  const { organisation } = useOrganisation()

  const isComplimentary = item.type === GiftItemType.Complimentary
  const isValid = isGiftItemValid(item, organisation, undefined, categories)
  const hasPrices = item.prices && item.prices.length > 0
  const noPricesNoValue = !hasPrices && !item.value
  const hasPricesButNoPublishedPrices = item.prices
    && item.prices.length > 0
    && item.prices.every((price) => price.status !== GiftItemStatus.Published)

  const handlePublishSwitch = async (publish: boolean): Promise<void> => {
    if (!organisation || !item.id) return

    const status = publish
      ? GiftItemStatus.Published
      : GiftItemStatus.Unpublished

    const res = await patchGiftItem({
      format: organisation.format,
      itemId: item.id,
      patchOptions: { status },
    })

    if (res) onSwitch(res)
  }

  return isComplimentary ? (
    <CompLabel small={small}>{getItemStatusText(item, organisation, categories)}</CompLabel>
  ) : (
    <Switch
      label={getItemStatusText(item, organisation, categories)}
      value={item.status === GiftItemStatus.Published}
      switchAction={handlePublishSwitch}
      disabled={
        item.status === GiftItemStatus.Unpublished
        && (!isValid || noPricesNoValue || hasPricesButNoPublishedPrices)
      }
      showConfirmation={publishFreeTicketWarning(item)}
      confirmationMessage="Are you sure you want to publish a free ticket?"
      flipLabel={flipLabel}
      small={small}
    />
  )
}
